import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import CustomLabel from 'components/Additional/CustomLabel/CustomLabel';

const CustomSelect = forwardRef(
	(
		{
			label,
			name,
			value,
			layout = 'vertical',
			tooltip,
			onChange,
			options,
			error,
		},
		ref,
	) => {
		const layoutClasses = twMerge(
			'flex-col',
			layout === 'horizontal' && 'md:flex-row md:items-start md:gap-4',
		);
		const labelClasses = twMerge(layout === 'horizontal' && 'pt-2');

		return (
			<div className={`w-full flex gap-2 ${layoutClasses}`}>
				{label && (
					<div className={labelClasses}>
						<CustomLabel label={label} tooltip={tooltip} />
					</div>
				)}
				<div className="flex flex-col w-full">
					<select
						className={`w-full py-2 md:py-2 px-3 md:px-5 box-border rounded-xl md:rounded-2xl text-base md:text-2xl border focus:outline-none focus:ring-0 ${
							error ? 'border-sfi-red' : 'border-sfi-blue'
						}`}
						name={name}
						id={name}
						value={value}
						onChange={onChange}
						ref={ref}
					>
						<option value="0" defaultValue>
							Please select
						</option>
						{options.map((option, index) => (
							<option key={index} value={option.value}>
								{option.name}
							</option>
						))}
					</select>
					<span className="text-sfi-red text-xs md:text-sm min-h-1 md:min-h-2">
						{error && error}
					</span>
				</div>
			</div>
		);
	},
);

export default CustomSelect;
